"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = void 0;

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

exports.Logo = function (_a) {
  var logo = _a.logo,
      header = _a.header,
      description = _a.description,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      rest = tslib_1.__rest(_a, ["logo", "header", "description", "className"]);

  return React.createElement("span", Object.assign({
    className: "clp-logo ".concat(rest.onClick ? 'c-pointer' : '', " ").concat(className)
  }, rest), React.createElement("img", {
    src: logo,
    alt: description
  }), React.createElement("h3", {
    className: 'clp-logo__label'
  }, header, React.createElement("small", {
    className: 'clp-logo__sub-label'
  }, description)));
};